define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.CiptexViewerUpdate = void 0;
    var CiptexViewerUpdate;
    (function (CiptexViewerUpdate) {
        let playerStatus;
        (function (playerStatus) {
            playerStatus["BUFFERING"] = "buffering";
            playerStatus["ENDED"] = "ended";
            playerStatus["IDLE"] = "idle";
            playerStatus["PLAYING"] = "playing";
            playerStatus["READY"] = "ready";
        })(playerStatus = CiptexViewerUpdate.playerStatus || (CiptexViewerUpdate.playerStatus = {}));
    })(CiptexViewerUpdate = exports.CiptexViewerUpdate || (exports.CiptexViewerUpdate = {}));
});
